const json = {
    GE: {
        BUTTON: 'გაგრძელება',
        DESCRIPTIONS: [
            'ეს ვებ გვერდი იყენებს Cookies-ს. ამ საიტზე ყოფნით თქვენ ეთანხმებით ჩვენ მიერ',
            'Cookies გამოყენებას.'
        ]
    },
    EN: {
        BUTTON: 'Got it',
        DESCRIPTIONS: [
            'This site uses cookies. By continuing to browse the site, you are agreeing to our',
            'use of cookies'
        ]
    }
}

export default json



// WEBPACK FOOTER //
// ./client/app/components/cookies/cookies.texts.js